import { generateTestId } from "@client-shared";

export const setInventoryViewTestId = (identifier: string): string => generateTestId("InventoryView", identifier);
